import React, { useContext, useState } from 'react';
import DepositCss from '../css/DepositCss';
import { useNavigate } from 'react-router-dom';
import { Context } from '../Context/Context';
import { Flip, toast } from 'react-toastify';
import { DeleteClientApi } from '../Api/DeleteClient'; // You need to create this API if not already done
import { Helmet } from 'react-helmet';
export default function DeleteClient() {
    const navigate = useNavigate();
    const { sessionDetail, setSessionDetail, setLoad, setLoadColor } = useContext(Context);

    const [selectedClientName, setSelectedClientName] = useState('');

    const handleDeleteClient = async () => {
        if (!selectedClientName) {
            toast.error("Please select a client to delete", { autoClose: 1500, theme: "colored", transition: Flip });
            return;
        }

        if (!window.confirm(`Are you sure you want to delete "${selectedClientName}"?`)) return;

        setLoad(true);
        setLoadColor("#FF0000");

        try {
            const userInfo = JSON.parse(localStorage.getItem('userinfo'));

            const res = await DeleteClientApi({
                username: userInfo?.username,
                user_id: userInfo?.userId,
                client_name: selectedClientName,
            });

            if (res.data.status) {
                const updatedClients = res.data.data?.user_clients || [];

                setSessionDetail(prev => ({
                    ...prev,
                    user_clients: updatedClients,
                }));

                const updatedUserInfo = {
                    ...userInfo,
                    user_clients: updatedClients
                };
                localStorage.setItem('userinfo', JSON.stringify(updatedUserInfo));

                toast.success('Client deleted successfully!', { autoClose: 3000, theme: "colored", transition: Flip });
                navigate("/game");
            } else {
                toast.error(res.data.message, { autoClose: 1500, theme: "colored", transition: Flip });
            }
        } catch (error) {
            toast.error("Something went wrong", { autoClose: 1500, theme: "colored", transition: Flip });
        } finally {
            setLoad(false);
        }
    };

    return (
        <DepositCss>
            <Helmet>
                {/* Page Title */}
                <title>Delete Client | Remove Client Data | Matka Jantri</title>

                {/* SEO Description */}
                <meta
                    name="description"
                    content="This page allows you to delete client information and data securely from MatkaJantri."
                />

                {/* SEO Directives */}
                <meta name="robots" content="noindex, nofollow" />

                {/* Canonical URL */}
                <link rel="canonical" href="https://pushpabetfair.com/delete-client" />

                {/* Favicon and Icons */}
                <link rel="icon" href="/favicon.ico" type="image/x-icon" />
                <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
                <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
                <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png" />

                {/* Mobile Optimization */}
                <meta name="viewport" content="width=device-width, initial-scale=1.0" />

                {/* Open Graph */}
                <meta property="og:title" content="Delete Client | Remove Client Data | MatkaJantri" />
                <meta
                    property="og:description"
                    content="This page allows you to delete client information and data securely from MatkaJantri."
                />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://pushpabetfair.com/delete-client" />
                <meta property="og:image" content="https://app.matkajantri.com/JantriImage/Logo.png" />
            </Helmet>

            <div className="w-100 fullpage">
                <div className="w-3">
                    <div className="back-top">
                        <i className="fa-solid fa-chevron-left" onClick={() => navigate("/game")}></i>
                    </div>
                    <div className="w-100 text-center d-flex">
                        <button className="addFunds danger">
                            <i className="fa-solid fa-user-minus"></i> Delete Client
                        </button>
                    </div>

                    <div className="w-100 px-3">
                        {/* Dropdown to select client */}
                        <div className="mb-3 w-100">
                            <label className="form-label">Select Client to Delete <span style={{ color: 'red' }}>*</span></label>
                            <select
                                className="form-control"
                                value={selectedClientName}
                                onChange={(e) => setSelectedClientName(e.target.value)}
                            >
                                <option value="">-- Select Client --</option>
                                {sessionDetail?.user_clients?.map((client, idx) => {
                                    const name = typeof client === 'string' ? client : client.client_name;
                                    return (
                                        <option key={idx} value={name}>
                                            {name}
                                        </option>
                                    );
                                })}
                            </select>
                        </div>

                        <div className="text-center">
                            <button className="submit-btn danger-btn" onClick={handleDeleteClient}>
                                Delete Client
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </DepositCss>
    );
}
